export default __webpack_public_path__ + "static/media/number-shine-3.e5a3d53a.svg";